exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".contact-modal{position:relative}.required label:after{content:\"*\";color:red;font-size:12px}", "", {"version":3,"sources":["/home/rubel/tasinShahriar/Project/NBR-GITLAB/dbas/Workspace/portal/nbrdiplomaticbond/src/components/Contact.vue"],"names":[],"mappings":"AACA,eACI,iBAAmB,CACtB,AACD,sBACI,YAAa,AACb,UAAW,AACX,cAAgB,CACnB","file":"Contact.vue","sourcesContent":["\n.contact-modal{\n    position: relative;\n}\n.required label::after {\n    content: \"*\";\n    color: red;\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60bc5877","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Contact.vue
// module id = 610
// module chunks = 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24